const initialState = {
    admin: false,
    user: false,
    superadmin: false
}; 

const routeSwitchHandler = ( state = initialState, action) => {
    // console.log('switching...................................................................................................................................................................')
    switch(action.type){
        case 'ADMIN_SWITCH_VALUE':
            //updatedState.admin = action.payload.adminValue;
            //updatedState.user = false;
            // console.log('.....................................................................Admin..............................................................................................')
            return Object.assign({
                admin: true,
                user: false,
                superadmin: false
            });
            
        case 'LOGOUT':
            // console.log('.....................................................................Logout..............................................................................................')
            return Object.assign({
                admin: false,
                user: false,
                superadmin: false
            })        

        case 'USER_SWITCH_VALUE':
            // console.log('.....................................................................User..............................................................................................')
            return Object.assign({
                admin: false,
                user: true,
                superadmin: false
            });

        case 'SUPER_SWITCH_VALUE':
            // console.log('.....................................................................Super..............................................................................................')
            return Object.assign({
                admin: true,
                user: false,
                superadmin: true
            });
            
            
        default :
            return state;
    }
};

export default routeSwitchHandler;